import {apolloClient, gql} from '../graphql';
import {normalizeGraphQLObject} from '../graphql/helpers';
import type {File, ID} from 'shared/src/models';

export const getFiles = async ({projectIds}: {projectIds?: ID[]} = {}): Promise<File[]> => {
	const {
		data: {files},
		error,
	} = await apolloClient.query({
		query: gql(/* GraphQL */ `
			query GetFiles($projectIds: [String!]) {
				files(projectIds: $projectIds) {
					id
					name
					description
					mimeType
					size
				}
			}
		`),
		variables: {
			projectIds,
		},
		fetchPolicy: 'no-cache',
	});

	if (error) {
		throw error;
	}

	return files.map(normalizeGraphQLObject);
};

export const deleteFile = async (id: string) => {
	await apolloClient.mutate({
		mutation: gql(/* GraphQL */ `
			mutation DeleteFile($id: ID!) {
				deleteFile(id: $id)
			}
		`),
		variables: {id},
	});
};
